import * as yup from 'yup';

const validationSignUp = yup.object().shape({
  email: yup.string().required('Required').email('Invalid email format'),
  name: yup
    .string()
    .required('Required')
    .matches(/^[a-zA-Z]{6,} [a-zA-Z]{6,}/, 'full name'),
  password: yup
    .string()
    .required('Required')
    .min(8, 'minimum 8 chars')
    .matches(/[a-zA-Z]/, 'Password can only contain Latin letters.'),
  repeatPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords do not match'),
});

export default validationSignUp;
